import React, { useCallback, useState } from 'react';

import { Modal } from 'antd';
import { Document, Page, Thumbnail } from 'react-pdf';
import { useIntersectionObserver } from '@wojtekmaj/react-hooks';

import { PreviewModalContainer, PreviewTemplateDetails } from '../../../components/Modals/styles';
import { PreviewInsertContainer } from './styles';
import { dummyCallback } from '../../../utils/complexDocumentConstants';

const observerConfig = {
  threshold: 0,
};

export const PreviewPageWithObserver = ({ pageNumber, setPageVisibility, type = 'page' }) => {
  const [page, setPage] = useState();

  const onIntersectionChange = useCallback(
    ([entry]) => {
      setPageVisibility(pageNumber, entry.isIntersecting);
    },
    [pageNumber, setPageVisibility],
  );

  useIntersectionObserver(page, observerConfig, onIntersectionChange);

  const Component = type === 'page' ? Page : type === 'thumbnail' ? Thumbnail : Page;

  let pageProps = {};
  if (type === 'thumbnail') {
    pageProps = { height: 250, width: 150 };
  } else if (type === 'preview') {
    pageProps = { height: 800, width: 450 };
  }

  return (
    <Component
      canvasRef={setPage}
      pageNumber={pageNumber}
      scale={1.4}
      renderTextLayer={false}
      renderAnnotationLayer={true}
      renderForms={true}
      loading=""
      error=""
      {...pageProps}
    />
  );
};

export const InsertPreviewModal = ({ visible, onCancel, insert }) => {
  const { url, name } = insert;
  const [numOfPages, setNumOfPages] = useState(0);
  return (
    <Modal
      title={null}
      centered
      visible={visible}
      width="60vw"
      onCancel={onCancel}
      style={{ padding: '0px !important' }}
      footer={null}
      className="insertPreviewModalView"
      closable={true}
    >
      <PreviewTemplateDetails>
        <h2>{name}</h2>
      </PreviewTemplateDetails>
      <PreviewModalContainer>
        <PreviewInsertContainer>
          <Document
            file={url}
            onLoadSuccess={({ numPages }) => setNumOfPages(numPages)}
            loading={
              <div
                style={{ width: 635, height: 899, background: '#fff', justifySelf: 'center' }}
              ></div>
            }
            error=""
            onLoadError={error => console.error({ error })}
            externalLinkTarget={'_blank'}
            onItemClick={dummyCallback}
          >
            {Array.from(new Array(numOfPages), (_, index) => (
              <div
                key={`page_preview${index + 1}`}
                className="page_preview_pageLayout"
                id={`page_preview_pdfPageNumber-${index + 1}`}
              >
                <PreviewPageWithObserver
                  key={`page_preview-${index + 1}`}
                  pageNumber={index + 1}
                  setPageVisibility={() => {}}
                  type="preview"
                />
              </div>
            ))}
          </Document>
        </PreviewInsertContainer>
      </PreviewModalContainer>
    </Modal>
  );
};
